import { TransitionControlUIFactory } from "./types";
import {
  DataType,
  ConfigType,
  builder,
  typeIsConfigType,
} from "@auditcloud/shared/lib/workflow/modules/Measure/transitionControls/comment";
import component from "../AMeasureTransitionCommentControl.reg.vue";

const factory: TransitionControlUIFactory<DataType, ConfigType> = config => {
  return {
    component,
    ...builder(config),
  };
};

export default {
  factory,
  typeIsConfigType,
};
